//Снимаем фокус с элемента после click
module.exports = global.blurOnLeave = function blurOnLeave(element) {
	var $element = $(element);
	$element.on('mouseleave', function () {
		$element.blur();
	});
};
